import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      © 2025 SortLearn Online | Developed by Computer Education, KMUTNB
    </footer>
  );
}
